import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Cookies from "js-cookie";
import {
  AdditionalDataPoints,
  GA_COOKIE_NAME,
  GA_SESSION_ID,
  RootState,
  afParameters,
  searchParamsStorage,
  serverOwnedConfigSelectors,
  setAppsFlyerDirectLinkURL,
  setAppsFlyerOneLinkURL,
  visitorSelectors,
} from "src/features/marketing/imports";
import {
  getGooglePlayApkLink,
  getOneLinkTemplate,
} from "src/features/marketing/imports/state";
import { marketingSelectors } from "src/features/marketing/state/selectors";

const selector = (state: RootState) => ({
  isServerConfigReady: serverOwnedConfigSelectors.getIsServerConfigReady(state),
  marketingAnalyticsKey: marketingSelectors.getAnalyticsKey(state),
  oneLinkTemplate: getOneLinkTemplate(state),
  googlePlayApkLink: getGooglePlayApkLink(state),
  visitorData: visitorSelectors.data(state),
});

export const useAppsFlyerMarketing = () => {
  const {
    isServerConfigReady,
    marketingAnalyticsKey,
    oneLinkTemplate,
    googlePlayApkLink,
    visitorData,
  } = useSelector(selector, shallowEqual);

  const analyticsKey = marketingAnalyticsKey || visitorData.analyticsKey;

  useEffect(() => {
    if (analyticsKey && window?.AF_SMART_SCRIPT && isServerConfigReady) {
      const setAppsFlyerLinks = async () => {
        const sessionIdValue =
          (await searchParamsStorage.getItem(AdditionalDataPoints.GA_ID)) ||
          Cookies.get(GA_COOKIE_NAME) ||
          GA_SESSION_ID;

        const afParametersWithAnalyticsKey = {
          googlePlayApkLink,
          oneLinkURL: oneLinkTemplate,
          afParameters: {
            ...afParameters,
            afCustom: [
              ...afParameters.afCustom,
              {
                paramKey: AdditionalDataPoints.GA_ID,
                keys: [AdditionalDataPoints.GA_ID],
                defaultValue: sessionIdValue,
              },
              {
                paramKey: AdditionalDataPoints.ANALYTICS_ID,
                keys: [AdditionalDataPoints.ANALYTICS_ID],
                defaultValue: analyticsKey,
              },
            ],
          },
        };

        await setAppsFlyerOneLinkURL(afParametersWithAnalyticsKey);
        await setAppsFlyerDirectLinkURL(afParametersWithAnalyticsKey);
      };

      setAppsFlyerLinks();
    }
  }, [analyticsKey, window?.AF_SMART_SCRIPT, isServerConfigReady]);
};
